/* eslint-disable max-statements */
import {
  addPaxToBasket,
  addTicketsToBasket,
  createBasket,
} from '../../api/basket';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { basketOperations, basketTypes } from '../../store/basket';

import { DAS_ADD_TICKETS_TO_BASKET_FAILED } from '../../constants/errors';
import { createError } from '../../store/errors';
import { messageOperations } from '../../store/messages';
import { reloadBasket } from './helpers';

const { ADD_TICKETS_TO_BASKET } = basketTypes;
const { sendMessage } = messageOperations;

export const performAddTicketsToBasket = function* performAddTicketsToBasket({
  payload,
}) {
  const {
    addToBasketFailed,
    getBasketSuccess,
    createBasketSuccess,
    resetBasket,
  } = basketOperations;

  try {
    if (!payload.hasBasket) {
      const createBasketResponse = yield call(createBasket, payload.bookingRef);

      if (createBasketResponse.errors) {
        // Handle web service errors.
        yield all(
          createBasketResponse.errors.map(error => put(createError(error))),
        );
        return;
      }

      yield put(
        createBasketSuccess(
          createBasketResponse.bookingRef,
          createBasketResponse.basket,
        ),
      );
    }

    const addToBasketResponse = yield call(
      addTicketsToBasket,
      payload.bookingRef,
      payload.tickets,
    );

    if (addToBasketResponse.errors) {
      // Handle web service errors.
      yield all(
        addToBasketResponse.errors.map(error => put(createError(error))),
      );

      yield put(addToBasketFailed());
      if (!payload.hasBasket) {
        yield put(resetBasket(payload.bookingRef));
      }
      return;
    }

    // SL says: current WS4 implementation is an all or nothing on add tickets to basket
    // so we can simply cater for all the pax we need to add
    // KBF supports partial success, so it needs to determine which pax it needs to add

    if (payload.additionalPax.length > 0) {
      const addPaxResponse = yield call(
        addPaxToBasket,
        payload.bookingRef,
        payload.additionalPax,
      );

      if (addPaxResponse.errors) {
        // Handle web service errors.
        yield all(addPaxResponse.errors.map(error => put(createError(error))));
        return;
      }
    }

    // reload basket after success add pax
    const basketResponse = yield call(reloadBasket, payload.bookingRef, false);

    if (basketResponse.errors) {
      return;
    }

    const ticketsAdded = payload.tickets.map(ticket => ticket.ticketName);

    const unique = [...new Set(ticketsAdded)].join(', ');

    yield put(
      sendMessage({
        type: 'success',
        displayType: 'toast',
        message: `Tickets successfully added to your basket: ${unique}`,
      }),
    );

    yield put(
      getBasketSuccess(basketResponse.bookingRef, basketResponse.basket),
    );
  } catch (error) {
    yield put(
      createError({
        code: DAS_ADD_TICKETS_TO_BASKET_FAILED,
      }),
    );
    yield put(addToBasketFailed());
    if (!payload.hasBasket) {
      yield put(resetBasket(payload.bookingRef));
    }
  }
};

export default takeLatest(ADD_TICKETS_TO_BASKET, performAddTicketsToBasket);
